const ruCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Имя вашего файла...",
    description: "Placeholder for file name input",
  },
};

export default ruCreateFile;
